/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Transaction_Expired_ContentInputs */

const en_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order has expired. Please subscribe again.`)
};

const ar_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت صلاحية هذا الطلب. يرجى الاشتراك مرة أخرى.`)
};

const de_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Bestellung ist abgelaufen. Bitte abonnieren Sie erneut.`)
};

const es_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este pedido ha caducado. Por favor, suscríbete de nuevo.`)
};

const fr_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette commande a expiré. Veuillez vous réabonner.`)
};

const it_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo ordine è scaduto. Ti preghiamo di abbonarti nuovamente.`)
};

const ja_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このご注文は有効期限が切れています。再度お申し込みください。`)
};

const ko_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문이 만료되었어요. 다시 구독해 주세요.`)
};

const pt_br_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O pedido expirou. Efetue a assinatura novamente.`)
};

const ru_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок действия этого заказа истек. Подпишитесь снова.`)
};

const th_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำสั่งซื้อนี้หมดอายุแล้ว โปรดสมัครสมาชิกใหม่อีกครั้ง`)
};

const tr_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu siparişin süresi doldu. Lütfen tekrar abone ol.`)
};

const zh_cn_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此笔订单已经过期，请重新购买。`)
};

const zh_tw_dialog_transaction_expired_content = /** @type {(inputs: Dialog_Transaction_Expired_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此筆訂單已經過期，請重新訂閱`)
};

/**
* | output |
* | --- |
* | "This order has expired. Please subscribe again." |
*
* @param {Dialog_Transaction_Expired_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_transaction_expired_content = /** @type {((inputs?: Dialog_Transaction_Expired_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Transaction_Expired_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_transaction_expired_content(inputs)
	if (locale === "ar") return ar_dialog_transaction_expired_content(inputs)
	if (locale === "de") return de_dialog_transaction_expired_content(inputs)
	if (locale === "es") return es_dialog_transaction_expired_content(inputs)
	if (locale === "fr") return fr_dialog_transaction_expired_content(inputs)
	if (locale === "it") return it_dialog_transaction_expired_content(inputs)
	if (locale === "ja") return ja_dialog_transaction_expired_content(inputs)
	if (locale === "ko") return ko_dialog_transaction_expired_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_transaction_expired_content(inputs)
	if (locale === "ru") return ru_dialog_transaction_expired_content(inputs)
	if (locale === "th") return th_dialog_transaction_expired_content(inputs)
	if (locale === "tr") return tr_dialog_transaction_expired_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_transaction_expired_content(inputs)
	return zh_tw_dialog_transaction_expired_content(inputs)
});